// extracted by mini-css-extract-plugin
export default {"certification":"certification__certification-rgTjk"};